module.exports = __webpack_public_path__ + "img/cases_ETE.283f0599.png";